<template>
    <v-col sm="6" cols="12">
        <v-row>
            <v-col cols="12" class="pa-0">
                <span class="grey--text text--darken-1">{{label}}</span>
                <p class="subtitle-1 font-weight-bold text-truncate">
                    {{dataObject[type].vereinsNr}}
                    <span v-if="$vuetify.breakpoint.smAndUp"> / </span><br v-else>
                    {{dataObject[type].teamName}}
                </p>
            </v-col>
        </v-row>
        <v-row class="grey--text text--darken-1">
            <v-col v-if="dataObject.saison.freieSpieler" cols="1" class="pa-0">
                frei
            </v-col>
            <v-col :cols="nameCols" class="pa-0">
                Pass/Name
            </v-col>
            <v-col cols="2"  class="pa-0 text-center">
                Bahn
            </v-col>
        </v-row>
        <v-row v-for="i in dataObject.getNrOfPartien()" :key="i" class="pb-2">
            <v-col v-if="dataObject.saison.freieSpieler" cols="1" class="pa-0">
                <v-checkbox v-model="dataObject.partien[i][type].spieler.frei"
                            @click="resetSpieler(i, type)"
                            color="primary" hide-details class="pt-0 mt-2"> <!---->
                </v-checkbox>
            </v-col>
        <!-- spieler mit Pass -->
            <v-col v-if="!dataObject.partien[i][type].spieler.frei" :cols="nameCols" class="pa-0" >
                <v-autocomplete v-model="dataObject.partien[i][type].spieler.id"
                                item-value="id" item-text="name" class="body-2"
                                @change="dataObject.setNameAndPassNrForSelectedSpieler(i, type, spielerListe)"
                                no-data-text="keine Daten gefunden" clearable
                                :items="spielerListe" outlined dense hide-details></v-autocomplete>
            </v-col>
        <!-- freier Spieler -->
            <v-col v-if="dataObject.partien[i][type].spieler.frei" cols="3"
                   class="pl-0 py-0 pr-2">
                <v-checkbox v-model="dataObject.partien[i][type].spieler.hatPass"
                            @change="switchHatPass(i, type)"
                            class="pt-0 mt-2 mb-4 ml-2" hide-details>
                    <template v-slot:label><span class="body-2">Pass?</span></template>
                </v-checkbox>
                <!--<v-checkbox color="primary" hide-details class="pt-0 mt-2 d-inline-block">
                </v-checkbox>-->
                <v-text-field v-if="dataObject.partien[i][type].spieler.hatPass"
                              class="body-2" :rules="[rules.required, rules.passNr]"
                              v-model="dataObject.partien[i][type].spieler.passNr"
                              oninput="javascript: if (this.value.length > 6)
                                  this.value = this.value.slice(0, 6);"
                              @change="searchForFreieSpieler(i, type)"
                              :hide-details="dataObject.partien[i][type].spieler.passNr.length==6"
                              outlined dense placeholder="Pass">
                </v-text-field>
            </v-col>
            <v-col v-if="dataObject.partien[i][type].spieler.frei" cols="6" class="pa-0">
                <v-text-field class="body-2 mb-2" :rules="[rules.required]"
                              v-model="dataObject.partien[i][type].spieler.nachname"
                              @change="searchForFreieSpieler(i, type)"
                              outlined dense hide-details placeholder="Nachname">
                </v-text-field>
                <v-text-field class="body-2" :rules="[rules.required]"
                              v-model="dataObject.partien[i][type].spieler.vorname"
                              @change="searchForFreieSpieler(i, type)"
                              outlined dense hide-details placeholder="Vorname">
                </v-text-field>
            </v-col>
        <!-- bahn -->
            <v-col cols="2" class="pa-0 pl-2">
                <v-text-field v-model="dataObject.partien[i][type].bahn" class="body-2"
                              :rules="[rules.required]" type="number" @input="dataObject.setBahnen($event, i, type)"
                              outlined dense hide-details >
                </v-text-field>
            </v-col>
        </v-row>
        <v-row class="grey--text text--darken-1">
            <v-col cols="12" :class="[{'pb-5': !dataObject.saison.freieSpieler},
                                      {'pb-0': dataObject.saison.freieSpieler}, 'px-0 pt-2']">
                Ersatzspieler/innen
            </v-col>
        </v-row>
        <v-row v-if="dataObject.saison.freieSpieler" class="grey--text text--darken-1">
            <v-col cols="1" class="px-0 pt-2 pb-5"></v-col>
            <v-col cols="2" class="px-0 pt-2 pb-5 ml-2">frei</v-col>
        </v-row>
        <span>
            <v-row v-for="j in dataObject.getNrOfErsatzspieler(type)" :key="j" class="pb-2">
                <v-col cols="1" class="pb-0 pt-2 px-0 grey--text text--darken-1">
                    E {{j}}
                </v-col>
                <v-col cols="2" class="pa-0" v-if="dataObject.saison.freieSpieler">
                    <v-checkbox v-model="dataObject[type].ersatzSpieler[j].frei"
                                @change="resetErsatzspieler(type, j)"
                                color="primary" hide-details class="pt-0 mt-2 ml-2">
                    </v-checkbox>
                </v-col>
                <v-col v-if="!dataObject[type].ersatzSpieler[j].frei"
                       :cols="dataObject.saison.freieSpieler?9:11" class="pa-0">
                    <v-autocomplete v-model="dataObject[type].ersatzSpieler[j].id"
                                    item-value="id" item-text="name" class="body-2"
                                    no-data-text="keine Daten gefunden" clearable
                                    @change="dataObject.setNameAndPassNrForSelectedErsatzSpieler(j, type, spielerListe)"
                                    :items="spielerListe" outlined dense hide-details>
                    </v-autocomplete>
                </v-col>
                <v-col v-if="dataObject[type].ersatzSpieler[j].frei" class="pa-0">
                    <v-checkbox v-model="dataObject[type].ersatzSpieler[j].hatPass"
                                @change="switchHatPassErsatz(j, type)"
                                class="pt-0 mt-2 mb-4" hide-details>
                        <template v-slot:label><span class="body-2">Pass?</span></template>
                    </v-checkbox>
                    <v-text-field v-if="dataObject[type].ersatzSpieler[j].hatPass"
                                  class="body-2 mr-2" :rules="[rules.required, rules.passNr]"
                                  v-model="dataObject[type].ersatzSpieler[j].passNr"
                                  oninput="javascript: if (this.value.length > 6)
                                      this.value = this.value.slice(0, 6);"
                                  @change="searchForFreieSpielerErsatz(j, type)"
                                  :hide-details="dataObject[type].ersatzSpieler[j].passNr.length==6"
                                  outlined dense placeholder="Pass">
                    </v-text-field>
                </v-col>
                <v-col v-if="dataObject[type].ersatzSpieler[j].frei" cols="6" class="pa-0">
                    <v-text-field class="body-2 mb-2" :rules="[rules.required]"
                                  v-model="dataObject[type].ersatzSpieler[j].nachname"
                                  @change="searchForFreieSpielerErsatz(j, type)"
                                  outlined dense hide-details placeholder="Nachname">
                    </v-text-field>
                    <v-text-field class="body-2" :rules="[rules.required]"
                                  v-model="dataObject[type].ersatzSpieler[j].vorname"
                                  @change="searchForFreieSpielerErsatz(j, type)"
                                  outlined dense hide-details placeholder="Vorname">
                    </v-text-field>
                </v-col>
            </v-row>
        </span>
        <v-row>
            <!--<v-col cols="2" class="px-0 pt-9">
                <span>Kapitän:</span>
            </v-col>-->
            <v-col class="px-0 pt-7 grow">
                <v-text-field v-if="!captainSelect" v-model="dataObject[type].captain"
                              class="body-2" label="Kapitän/in (Freitext)"
                              :rules="[rules.required]" outlined dense hide-details >
                </v-text-field>
                <v-autocomplete v-else v-model="dataObject[type].captain"
                                class="body-2" label="Kapitän/in (aus Mannschaft wählen)"
                                :rules="[rules.required]" outlined dense hide-details
                                no-data-text="keine Daten gefunden" :items="spielerListeCaptain"
                                item-value="name" item-text="name" clearable>
                </v-autocomplete>
            </v-col>
            <v-col class="pr-0 pl-1 pt-7 shrink">
                <v-btn icon @click="captainSelect=!captainSelect">
                    <v-icon :color="captainSelect?'success':'grey'">mdi-magnify</v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <!--<v-btn @click="dataObject.setZufallMaLTeam(spielerListe, type)">Test Mannschaftsdaten</v-btn>-->
    </v-col>
</template>

<script>
    import {db} from "../../../../services/db";
    import SPIELER_MEMBERSHIP_HANDLER from "../../../../services/data/spieler/spielerMembershipHandler";
    export default {
        name: "spiel-bericht-edit-ma-l-team",
        props: ['dataObject', 'rules', 'type'],
        computed: {
            label(){ return this.type === 'heim' ? 'Heim' : 'Gast'; },
            nameCols() { return this.dataObject.saison.freieSpieler ? 9 : 10 },
        },
        data: () => ({
            spielerListe: [],
            spielerListeCaptain: [],
            captainSelect: false,
        }),
        created(){
            this.loadSpieler();
        },
        methods: {
            resetSpieler(partieId, type){
                const frei = this.dataObject.partien[partieId][type].spieler.frei;
                // ACHTUNG: auch in spielPartie.js aktualisieren
                this.dataObject.partien[partieId][type].spieler = {
                        id: '',
                        passNr: '',
                        name: '',
                        nationalitaet: '',
                        akHJ: '',
                        akJahr: '',
                };
                if ( this.dataObject.saison.freieSpieler ) {
                    this.dataObject.partien[partieId][type].spieler.frei = frei;
                    this.dataObject.partien[partieId][type].spieler.hatPass = false;
                }
                /*this.dataObject.partien[partieId].resetSpieler(type, this.dataObject.saison.freieSpieler );
                this.dataObject.partien[partieId][type].spieler.frei = frei;*/
            },
            resetErsatzspieler(type, pos){
                this.dataObject[type].ersatzSpieler[pos] =
                    this.dataObject.getEmptyErsatzspielerObjekt(
                        this.dataObject[type].ersatzSpieler[pos].eintauschVorFuer !== undefined,
                        this.dataObject[type].ersatzSpieler[pos].frei
                    );
            },
            switchHatPass(i, type){
                console.log ('switchHatPass' );
                this.dataObject.partien[i][type].spieler.passNr = '';
                if ( !this.dataObject.partien[i][type].spieler.hatPass ) {
                    this.searchForFreieSpieler(i, type);
                }
            },
            switchHatPassErsatz(j, type){
                this.dataObject[type].ersatzSpieler[j].passNr = '';
                if ( !this.dataObject[type].ersatzSpieler[j].hatPass ) {
                    this.searchForFreieSpielerErsatz(j, type);
                }
            },
            searchForFreieSpieler(i, type){
                let spieler = this.dataObject.partien[i][type].spieler;
            // check if freie Spieler document is already bound

            // search in document

            // create new spieler
                const uniqueKey = 'f' + i + type.substr(0,1);
                spieler.id = uniqueKey + this.dataObject.id.substr(0,17);
                if ( !spieler.passNr && !spieler.hatPass ) {
                    spieler.passNr = uniqueKey + this.dataObject.id.substr(0,3)
                }
                spieler.nachname = spieler.nachname ? spieler.nachname.toUpperCase() : "";
                spieler.name = spieler.passNr + ' / ' + spieler.nachname + ' ' + spieler.vorname;
            },
            searchForFreieSpielerErsatz(i, type){
                let spieler = this.dataObject[type].ersatzSpieler[i];
                // check if freie Spieler document is already bound

                // search in document

                // create new spieler
                const uniqueKey = 'e' + i + type.substr(0,1);
                spieler.id = uniqueKey + this.dataObject.id.substr(0,17);
                if ( !spieler.passNr && !spieler.hatPass ) {
                    spieler.passNr = uniqueKey + this.dataObject.id.substr(0,3)
                }
                spieler.nachname = spieler.nachname ? spieler.nachname.toUpperCase() : "";
                const vorname = spieler.vorname ? ' ' + spieler.vorname : '';
                spieler.name = spieler.passNr + ' / ' + spieler.nachname + vorname;
            },
            loadSpieler(){
                if ( this.dataObject[this.type].vereinsNr.length === 5 &&
                     this.spielerListe.length === 0 ) {
                    this.spielerListe = [];
                    this.spielerListeCaptain = [];
                    const ligaGeschlecht = this.dataObject.getLigaData('type');
                    const membershipYear = this.dataObject[this.type].vereinsNr + "_" +
                                            this.dataObject.getSportJahr();
                    // database call
                    db.collection("spieler")
                        .where("search.membershipYears." + membershipYear, "==", true)
                        .get()
                        .then((querySnapshot) => {
                            querySnapshot.forEach((doc) => {
                                const data = doc.data();
                                if ( ligaGeschlecht === 'other' || ligaGeschlecht === data.geschlecht ) {
                                    const passNr = SPIELER_MEMBERSHIP_HANDLER
                                                        .getMembershipForAufstellung(data.memberships,
                                                            this.dataObject[this.type].vereinsNr)?.passNr;
                                    if ( !isNaN(passNr) ) {
                                        this.spielerListe.push( {
                                            id: doc.id,
                                            name: passNr + " / " + data.nachname + " " + data.vorname,
                                            passNr: passNr,
                                            akHJ: data.dates.akHJ ? data.dates.akHJ : '',
                                            akJahr: data.dates.akJahr ? data.dates.akJahr : '',
                                        });
                                        this.spielerListeCaptain.push( {
                                            name: data.nachname + " " + data.vorname,
                                        });
                                    }
                                }
                            });
                            this.spielerListe.sort((a, b) => a.name.substr(9) > b.name.substr(9) ? 1 : -1);
                            this.spielerListeCaptain.sort((a, b) => a.name > b.name ? 1 : -1);
                        })
                        .catch((error) => {
                            console.log("Error getting documents: ", error);
                        });
                }
            }
        },
        watch: {
            dataObject: {
                handler(to, from){
                    if ( !from ) {
                        console.log ("watch dataObject");
                        this.loadSpieler();
                    }
                },
                deep: true
            },
        }
    }
</script>

<style scoped>

</style>